import {
  Button,
  ClickAwayListener,
  Grow,
  ListItemIcon,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from "@mui/material";
import { UsersThree } from "@phosphor-icons/react/dist/ssr";
import React, { useEffect, useRef, useState } from "react";
import ClientSMSDialog from "components/ClientSMSDialog";

export const TeamSelect = ({ teams = [], selectedTeam = null, onTeamSelect }) => {
  const [open, setOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedMemberId, setSelectedMemberId] = useState(null);
  const anchorRef = useRef(null);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleTeamSelect = (team) => {
    if (onTeamSelect) {
      onTeamSelect(team);
    }
    setSelectedMemberId(team.userId); // Before i was using team.id but teamMember.id doesnt work
    setDialogOpen(true);
    setOpen(false);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setSelectedMemberId(null);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === "Escape") {
      setOpen(false);
    }
  }

  const prevOpen = useRef(open);
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      if (anchorRef.current) {
        anchorRef.current.focus();
      }
    }
    prevOpen.current = open;
  }, [open]);

  return (
    <div>
      <Button
        ref={anchorRef}
        id="team-select-button"
        color="secondary"
        disabled={teams.length === 0}
        aria-controls={open ? "team-select-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
      >
        Open Messages
      </Button>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        placement="bottom-start"
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === "bottom-start" ? "left top" : "left bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={open}
                  id="team-select-menu"
                  aria-labelledby="team-select-button"
                  onKeyDown={handleListKeyDown}
                >
                  {teams.length === 0 ? (
                    <MenuItem disabled>No teams available</MenuItem>
                  ) : (
                    teams
                      .filter((team) => team.userId != null)
                      .map((team) => (
                        <MenuItem
                          key={team.id}
                          onClick={() => handleTeamSelect(team)}
                          selected={selectedTeam && selectedTeam.id === team.id}
                        >
                          <ListItemIcon>
                            <UsersThree />
                          </ListItemIcon>
                          {team.name}
                        </MenuItem>
                      ))
                  )}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>

      <ClientSMSDialog
        open={dialogOpen}
        onCloseDialog={handleDialogClose}
        teamMemberUserId={selectedMemberId}
      />
    </div>
  );
};

export default TeamSelect;
